import React from "react";
import { useState } from "react";
import { apiCall } from "../../services/api";
import { TextField, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
  },
  envelopeId: {
    marginTop: "16px",
    padding: "8px",
    backgroundColor: theme.palette.grey[100],
    borderRadius: "4px",
  },
}));

const sendTestEnvelope = async (email) => {
  const { envelopeId } = await apiCall(
    "POST",
    "/api/docusign-admin/send-test-envelope",
    { email }
  );
  return envelopeId;
};

export const SendTestEnvelopeForm = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [envelopeId, setEnvelopeId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const envelopeId = await sendTestEnvelope(email);
      setEnvelopeId(envelopeId);
      setEmail("");
      setError("");
    } catch (error) {
      setError(error.data.error || "Failed to send test envelope");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <TextField
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        fullWidth
        variant="outlined"
        size="small"
        style={{
          backgroundColor: "white",
        }}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={isSubmitting}
        fullWidth
      >
        {isSubmitting ? "Sending..." : "Send Test Envelope"}
      </Button>
      {envelopeId && (
        <Typography variant="body2">Envelope ID: {envelopeId}</Typography>
      )}
      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}
    </form>
  );
};
